"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeStatusValue = normalizeStatusValue;
exports.normalizedStatusEquals = normalizedStatusEquals;
exports.normalizedStatusIn = normalizedStatusIn;
function applyCaseMode(value, caseMode) {
    return caseMode === "lower" ? value.toLowerCase() : value.toUpperCase();
}
function normalizeStatusValue(rawStatus, options = {}) {
    const { fallback = "UNKNOWN", caseMode = "upper" } = options;
    if (typeof rawStatus === "string" && rawStatus.trim().length > 0) {
        return applyCaseMode(rawStatus.trim(), caseMode);
    }
    return applyCaseMode(fallback.trim(), caseMode);
}
function normalizedStatusEquals(rawStatus, expectedStatus, options = {}) {
    const { caseMode = "upper" } = options;
    const normalizedRaw = normalizeStatusValue(rawStatus, options);
    const normalizedExpected = normalizeStatusValue(expectedStatus, {
        fallback: expectedStatus,
        caseMode,
    });
    return normalizedRaw === normalizedExpected;
}
function normalizedStatusIn(rawStatus, expectedStatuses, options = {}) {
    return expectedStatuses.some((status) => normalizedStatusEquals(rawStatus, status, options));
}
